import { Stack } from "@mui/material";
import { TutorialDto } from "../../../api/psc";
import { DialogContainer, DialogHeader } from "../../../components/exports";

export default function TutorialDialog(props: { item: TutorialDto }) {
    return (
        <DialogContainer preferredWith={1024}>
            <DialogHeader title={props.item.title} />
            <Stack justifyContent="space-around" sx={{ height: "80%" }}>
                <video
                    src={props.item.videoUri}
                    style={{ float: "left" }}
                    autoPlay={true}
                    poster={props.item.thumbnailUri}
                    controls={true}
                />
            </Stack>
        </DialogContainer>
    );
}
